<template>
<div>
    <div class="d-flex flex-column-fluid">
        <!--begin::Container-->
        <div class="container-fluid">
            <div class="row">
                <div class="col-12">
                    <div class="row">
                        <div class="col-lg-12 col-xl-12">
                            <div class="card card-custom gutter-b bg-transparent shadow-none border-0">
                                <div class="card-header align-items-center  border-bottom-dark px-0">
                                    <div class="card-title mb-0">
                                        <h3 class="card-label mb-0 font-weight-bold text-body">
                                            Customer
                                        </h3>
                                    </div>
                                    <div class="icons d-flex">
                                        <button class="btn ml-2 p-0 kt_notes_panel_toggle" data-toggle="tooltip" title="" data-placement="right" data-original-title="Check out more demos" v-if="$parent.permissions.includes('customer-manage')">
                                            <span class="bg-secondary h-30px font-size-h5 w-30px d-flex align-items-center justify-content-center  rounded-circle shadow-sm " v-on:click="
                                                        display_form = !display_form
                                                    ">
                                                <svg width="25px" height="25px" viewBox="0 0 16 16" class="bi bi-plus white" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                                                    <path fill-rule="evenodd" d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4z"></path>
                                                </svg>
                                            </span>
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-12 ">
                            <div class="card card-custom gutter-b bg-white border-0">
                                <div class="card-body">
                                    <div>
                                        <div class=" table-responsive" id="printableTable">
                                            <div id="productUnitTable_wrapper" class="dataTables_wrapper no-footer">

                                                <div class="dataTables_length" id="productUnitTable_length"><label>Показать
                                                        <select name="productUnitTable_length"  class="" v-model="limit" v-on:change="fetchcustomers()">
                                                            <option value="10">10</option>
                                                            <option value="25">25</option>
                                                            <option value="50">50</option>
                                                            <option value="100">100</option>
                                                            <option value="200">200</option>
                                                            <option value="500">500</option>
                                                            <option value="1000">1000</option>
                                                        </select> entries</label></div>

                                                <div id="productUnitTable_filter" class="dataTables_filter">
                                                <label>Поиск:<input type="text" class="" placeholder=""  v-model="searchParameter" @keyup="fetchcustomers()"></label>
                                                <button v-if="this.searchParameter != ''" @click="clearSearch">Очистить</button>
                                                </div>
                                                <table id="productUnitTable" class="display dataTable no-footer" role="grid">
                                                    <thead class="text-body">
                                                        <tr role="row">
                                                            <th class="sorting_asc" tabindex="0"  rowspan="1" colspan="1" aria-sort="ascending" aria-label="ID: activate to sort column descending" style="width: 31.25px;" @click="sorting('id')" :class="(this.$data.sortType == 'asc' || this.$data.sortType == 'ASC') && this.$data.sortBy == 'id'  ? 'sorting_asc' : (this.$data.sortType == 'desc' || this.$data.sortType == 'DESC') && this.$data.sortBy == 'id' ? 'sorting_desc' : 'sorting'">
                                                                ID
                                                            </th>
                                                            <th class="sorting" tabindex="0"  rowspan="1" colspan="1" aria-label="First Name: activate to sort column ascending" style="width: 95.5288px;" @click="sorting('first_name')" :class="(this.$data.sortType == 'asc' || this.$data.sortType == 'ASC') && this.$data.sortBy == 'first_name'  ? 'sorting_asc' : (this.$data.sortType == 'desc' || this.$data.sortType == 'DESC') && this.$data.sortBy == 'first_name' ? 'sorting_desc' : 'sorting'">
                                                                Имя
                                                            </th>
                                                            <th class="sorting" tabindex="0"  rowspan="1" colspan="1" aria-label="Last Name: activate to sort column ascending" style="width: 81.8109px;" @click="sorting('last_name')" :class="(this.$data.sortType == 'asc' || this.$data.sortType == 'ASC') && this.$data.sortBy == 'last_name'  ? 'sorting_asc' : (this.$data.sortType == 'desc' || this.$data.sortType == 'DESC') && this.$data.sortBy == 'last_name' ? 'sorting_desc' : 'sorting'">
                                                                Фамилия
                                                            </th>
                                                            <th class="sorting" tabindex="0"  rowspan="1" colspan="1" aria-label="Is Seen: activate to sort column ascending" style="width: 158.462px;">
                                                                Email
                                                            </th>
                                                            <th class="sorting" tabindex="0"  rowspan="1" colspan="1" aria-label="Status: activate to sort column ascending" style="width: 114.84px;">
                                                                Статус
                                                            </th>

                                                            <th  v-if="$parent.permissions.includes('customer-manage')" class="no-sort sorting_disabled" rowspan="1" colspan="1" aria-label="Action" style="width: 53.1891px;">
                                                                Действия
                                                            </th>
                                                        </tr>
                                                    </thead>
                                                    <tbody class="kt-table-tbody text-dark">
                                                        <tr class="kt-table-row kt-table-row-level-0 odd" role="row" v-for="customer in customers" v-bind:key="customer.id">
                                                            <td class="sorting_1">
                                                                {{customer.customer_id}}
                                                            </td>
                                                            <td>
                                                                {{ customer.customer_first_name }}
                                                            </td>
                                                            <td>
                                                                {{ customer.customer_last_name }}
                                                            </td>
                                                            <td>
                                                                {{ customer.customer_email }}
                                                            </td>
                                                            <td>
                                                                {{ customer.customer_status == '1' ? 'Активен' : 'Неактивен' }}
                                                            </td>
                                                            <td  v-if="$parent.permissions.includes('customer-manage')">
                                                                <a href="javascript:void(0)" class=" click-edit" id="click-edit1" data-toggle="tooltip" title="" data-placement="right" data-original-title="Check out more demos" @click="editcustomer(customer)"><i class="fa fa-edit"></i></a>
                                                                <a class="" href="#" @click="deletecustomer(customer.customer_id)"><i class="fa fa-trash"></i></a>
                                                            </td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                                <ul class="pagination pagination-sm m-0 float-right">
                                                    <li v-bind:class="[{disabled: !pagination.prev_page_url}]"><button class="page-link" href="#" @click="fetchcustomers(pagination.prev_page_url)">Previous</button></li>

                                                    <li class="disabled">
                                                        <span class="page-link text-dark text-center" href="#">Стр {{ pagination.current_page }} из {{ pagination.last_page }}</span>
                                                        <span class="page-link text-dark">Перейти на <input style="width:25px;border:1px solid #dee2e6;text-align: center;" type="text" v-model="pagination.current_page" @keyup="changePage()" /></span>
                                                    </li>

                                                    <li v-bind:class="[{disabled: !pagination.next_page_url}]" class="page-item"><button class="page-link" href="#" @click="fetchcustomers(pagination.next_page_url)">Next</button></li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="offcanvas offcanvas-right kt-color-panel p-5 kt_notes_panel" v-if="display_form == 1" :class="display_form ? 'offcanvas-on' : ''">
        <div class="offcanvas-header d-flex align-items-center justify-content-between pb-3">
            <h4 class="font-size-h4 font-weight-bold m-0">{{ edit ? "Изменить" :"Добавить" }} клиента</h4>
            <a href="#" class="btn btn-sm btn-icon btn-light btn-hover-primary kt_notes_panel_close" v-on:click="clearForm()">
                <svg width="20px" height="20px" viewBox="0 0 16 16" class="bi bi-x" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                    <path fill-rule="evenodd" d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z"></path>
                </svg>
            </a>
        </div>
        <form id="myform">
            <div class="form-row">
                <div class="form-group col-md-6">
                    <label class="text-dark">Имя</label>
                    <input type="text" name="text" v-model="customerData.customer_first_name" class="form-control" />
                    <small class="form-text text-danger" v-if="errors.has('first_name')" v-text="errors.get('first_name')"></small>
                </div>
                <div class="form-group col-md-6">
                    <label class="text-dark">Фамилия</label>
                    <input type="text" name="text" v-model="customerData.customer_last_name" class="form-control" />
                    <small class="form-text text-danger" v-if="errors.has('last_name')" v-text="errors.get('last_name')"></small>
                </div>
            </div>
            <div class="form-row">
                <div class="form-group col-md-6">
                    <label class="text-dark">Адрес</label>
                    <input type="text" name="text" v-model="customerData.customer_address" class="form-control" />
                    <small class="form-text text-danger" v-if="errors.has('address')" v-text="errors.get('address')"></small>
                </div>
                <div class="form-group col-md-6">
                    <label class="text-dark">Город</label>
                    <input type="text" name="text" v-model="customerData.customer_city" class="form-control" />
                    <small class="form-text text-danger" v-if="errors.has('city')" v-text="errors.get('city')"></small>
                </div>
            </div>
            <div class="form-row">
                <div class="form-group col-md-6">
                    <label class="text-dark">Индекс</label>
                    <input type="text" name="text" v-model="customerData.customer_zip" class="form-control" />
                    <small class="form-text text-danger" v-if="errors.has('zip')" v-text="errors.get('zip')"></small>
                </div>
                <div class="form-group col-md-6">
                    <label class="text-dark">Страна </label>
                    <Select2 v-model="customerData.customer_country_id" :options="countries" />
                    <small class="form-text text-danger" v-if="errors.has('country_id')" v-text="errors.get('country_id')"></small>
                </div>
            </div>
            <div class="form-row">
                <div class="form-group col-md-6">
                    <label class="text-dark">Телефон</label>
                    <input type="text" name="text" v-model="customerData.customer_phone" class="form-control" />
                    <small class="form-text text-danger" v-if="errors.has('phone')" v-text="errors.get('phone')"></small>
                </div>
                <div class="form-group col-md-6">
                    <label class="text-dark">Email</label>
                    <input type="email" name="text" v-model="customerData.customer_email" class="form-control" />
                    <small class="form-text text-danger" v-if="errors.has('email')" v-text="errors.get('email')"></small>
                </div>
            </div>
            <div class="form-row">
                <div class="form-group col-md-12">
                    <label class="text-dark">Наименование</label>
                    <input type="text" name="text" v-model="customerData.customer_company_name" class="form-control" />
                    <small class="form-text text-danger" v-if="errors.has('company_name')" v-text="errors.get('company_name')"></small>
                </div>
            </div>
            <div class="form-row" v-if="isRussia">
                <div class="form-group col-md-6">
                    <label class="text-dark">Тип контрагента</label>
                    <select class="form-control" v-model="customerData.counterparty_type">
                        <option value="company">Организация (ООО и др.)</option>
                        <option value="entrepreneur">ИП</option>
                        <option value="person">Физическое лицо</option>
                    </select>
                </div>
            </div>

            <div class="form-row" v-if="!isRussia || customerData.counterparty_type !== 'person'">
                <div class="form-group col-md-6">
                    <label class="text-dark">{{ isRussia ? 'ОГРН' + (customerData.counterparty_type === 'entrepreneur' ? 'ИП' : '') : 'Рег. номер' }}</label>
                    <input type="text" name="text" v-model="customerData.customer_registration_number" class="form-control" />
                    <small class="form-text text-danger" v-if="errors.has('registration_number')" v-text="errors.get('reg_nr')"></small>
                </div>
                <div class="form-group col-md-6">
                    <label class="text-dark">{{ isRussia ? 'ИНН' : 'НДС номер' }}</label>
                    <input type="text" name="text" v-model="customerData.customer_tax_number" class="form-control" />
                    <small class="form-text text-danger" v-if="errors.has('tax_number')" v-text="errors.get('vat_nr')"></small>
                </div>
            </div>

            <!-- КПП есть только у организаций в РФ -->
            <div class="form-row" v-if="isRussia && customerData.counterparty_type === 'company'">
                <div class="form-group col-md-6">
                    <label class="text-dark">КПП</label>
                    <input type="text" v-model="customerData.customer_kpp" class="form-control" />
                </div>
            </div>
            <div class="form-row">
                <div class="form-group col-md-12">
                    <label class="text-dark">Юридический адрес</label>
                    <input type="text" name="text" v-model="customerData.company_address" class="form-control" />
                    <small class="form-text text-danger" v-if="errors.has('company_address')" v-text="errors.get('company_address')"></small>
                </div>
            </div>
            <div class="form-row">
                <div class="form-group col-md-6">
                    <label class="text-dark">Банк</label>
                    <input type="text" name="text" v-model="customerData.bank" class="form-control" />
                    <small class="form-text text-danger" v-if="errors.has('bank')" v-text="errors.get('bank')"></small>
                </div>
                <div class="form-group col-md-6" v-if="isRussia">
                    <label class="text-dark">БИК</label>
                    <input type="text" v-model="customerData.bik" class="form-control" />
                </div>
                <div class="form-group col-md-6" v-if="isRussia">
                    <label class="text-dark">Расчётный счёт</label>
                    <input type="text" v-model="customerData.checking_account" class="form-control" />
                </div>
                <div class="form-group col-md-6" v-if="isRussia">
                    <label class="text-dark">Корр. счёт</label>
                    <input type="text" v-model="customerData.corr_account" class="form-control" />
                </div>
                <div class="form-group col-md-6" v-if="!isRussia">
                    <label class="text-dark">SWIFT</label>
                    <input type="text" name="text" v-model="customerData.swift" class="form-control" />
                    <small class="form-text text-danger" v-if="errors.has('swift')" v-text="errors.get('swift')"></small>
                </div>
                <div class="form-group col-md-12" v-if="!isRussia">
                    <label class="text-dark">IBAN</label>
                    <input type="text" name="text" v-model="customerData.iban" class="form-control" />
                    <small class="form-text text-danger" v-if="errors.has('iban')" v-text="errors.get('iban')"></small>
                </div>
            </div>
            <div class="form-row">
                <div class="form-group col-md-6">
                    <label class="text-dark">Пароль</label>
                    <input type="text" name="text" v-model="customerData.password" class="form-control" />
                    <small class="form-text text-danger" v-if="errors.has('password')" v-text="errors.get('password')"></small>
                </div>
                <div class="form-group col-md-6">
                    <label>Статус</label>
                    <select class="js-example-basic-single js-states form-control bg-transparent" v-model='customerData.customer_status'>
                        <option v-bind:selected="customerData.customer_status == 1" value="1">Активен</option>
                        <option v-bind:selected="customerData.customer_status == 0" value="0">Неактивен</option>
                    </select>
                    <small class="form-text text-danger" v-if="errors.has('state_id')" v-text="errors.get('status')"></small>
                </div>
            </div>

            <button type="button" @click="addcustomer()" class="btn btn-primary" style="position: absolute; right: 39px">Сохранить</button>
        </form>
    </div>
</div>
</template>

<script>
import ErrorHandling from "../../ErrorHandling";
export default {
    data() {
        return {
            display_form: 0,
            customerData: {
                customer_id: "",
                customer_first_name: "",
                customer_last_name: "",
                customer_email: "",
                customer_hash: "",
                customer_address: "",
                customer_city: "",
                customer_zip: "",
                customer_country_id: "",
                customer_phone: "",
                customer_registration_number: "",
                customer_tax_number: "",
                customer_kpp: "",
                counterparty_type: "company",
                bik: "",
                checking_account: "",
                corr_account: "",
                company_address: "",
                bank: "",
                swift: "",
                iban: "",
                is_seen: "",
                customer_status: 1,
                customer_company_name: "",
                password: ""
            },
            countries: [],
            states: [],
            error_message: '',
            edit: false,
            pagination: {},
            request_method: "",
            customers: [],
            token: [],
            searchParameter: '',
            sortBy: 'id',
            sortType: 'ASC',
            limit: 10,
            actions: false,
            errors: new ErrorHandling(),
            csrf: document.querySelector('meta[name="csrf-token"]').getAttribute("content")
        };
    },

    computed: {
        isRussia() {
            const country = this.countries.find(c => c.id == this.customerData.customer_country_id);

            return country ? /russia|росси/i.test(country.text || '') : false;
        },
    },

    methods: {

        fetchCountries() {
            this.$parent.loading = true;
            var token = localStorage.getItem('token');
            const config = {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            };
            var responseData = {};

            axios.get('/api/admin/country?getAllData=1', config)
                .then(res => {
                    if (res.data.status == "Success") {
                        const list = res.data.data.map(country => ({
                            id: country.country_id,
                            text: country.country_name
                        }));

                        // Countries we actually work with go first; the rest keep
                        // their original order.
                        const isPinned = c => /russia|росси|latvia|латви/i.test(c.text || '');
                        const pinnedOrder = c => (/russia|росси/i.test(c.text || '') ? 0 : 1);

                        this.countries = [
                            ...list.filter(isPinned).sort((a, b) => pinnedOrder(a) - pinnedOrder(b)),
                            ...list.filter(c => !isPinned(c)),
                        ];
                        //this.countries = res.data.data;
                    }
                }).finally(() => (this.$parent.loading = false));
        },
        fetchcustomers(page_url) {
            this.$parent.loading = true;
            let vm = this;
            page_url = page_url || "/api/admin/customer";
            var arr = page_url.split('?');

            if (arr.length > 1) {
                page_url += '&limit=' + this.limit;
            } else {
                page_url += '?limit=' + this.limit;
            }
            if (this.searchParameter != null) {
                page_url += '&searchParameter=' + this.searchParameter;
            }
            page_url += '&sortBy=' + this.sortBy + '&sortType=' + this.sortType + '&getCountry=1&getState=1';
            var responseData = {};

            axios.get(page_url, this.token).then(res => {
                this.customers = res.data.data;
                vm.makePagination(res.data.meta, res.data.links);
            }).finally(() => (this.$parent.loading = false));
        },
        changePage(){
          if(this.timer){
              clearTimeout(this.timer);
          }
          this.timer = setTimeout(() => {
              if(this.pagination.current_page>this.pagination.last_page) {
                  this.pagination.current_page = this.pagination.last_page
              } else if(this.pagination.current_page<1 || isNaN(this.pagination.current_page)) {
                  this.pagination.current_page = 1
              }
              this.fetchcustomers('/api/admin/customer?page='+this.pagination.current_page);
          }, 1000)
        },
        makePagination(meta, links) {
            let pagination = {
                current_page: meta.current_page,
                last_page: meta.last_page,
                next_page_url: links.next,
                prev_page_url: links.prev
            };

            this.pagination = pagination;
        },
        deletecustomer(id) {
            if (confirm('Are You Sure?')) {
                this.$parent.loading = true;
                axios.delete(`/api/admin/customer/${id}`, this.token)
                    .then(res => {
                        if (res.data.status == "Success") {
                            this.$toaster.success(res.data.message)
                            this.fetchcustomers();
                        }

                    })
                    .catch(err => console.log(err))
                    .finally(() => (this.$parent.loading = false));
            }
        },
        addcustomer() {
            this.$parent.loading = true;
            var url = '/api/admin/customer';
            if (this.edit === false) {
                // Add
                this.request_method = 'post'
            } else {
                // Update
                var url = '/api/admin/customer/' + this.customerData.customer_id;
                this.request_method = 'put'
            }
            axios[this.request_method](url, {
                        'first_name': this.customerData.customer_first_name,
                        'gallary_id': 1,
                        'last_name': this.customerData.customer_last_name,
                        'email': this.customerData.customer_email,
                        'status': this.customerData.customer_status,
                        'password': this.customerData.password,
                    'customer_address_id': this.customerData.customer_address_id,
                    'address': this.customerData.customer_address,
                    'company': this.customerData.customer_company_name,
                    'city': this.customerData.customer_city,
                    'zip': this.customerData.customer_zip,
                    'country_id': this.customerData.customer_country_id,
                    'phone': this.customerData.customer_phone,
                    'reg_nr': this.customerData.customer_registration_number,
                    'company_address': this.customerData.company_address,
                    'vat_nr': this.customerData.customer_tax_number,
                    'kpp': this.customerData.customer_kpp,
                    'counterparty_type': this.customerData.counterparty_type,
                    'bik': this.customerData.bik,
                    'checking_account': this.customerData.checking_account,
                    'corr_account': this.customerData.corr_account,
                    'bank': this.customerData.bank,
                    'swift': this.customerData.swift,
                    'iban': this.customerData.iban,
                'is_legal_person': (this.customerData.customer_company_name)? 1: 0,
                    },
                    this.token)
                .then(res => {
                    if (res.data.status == "Success") {
                        this.display_form = 0;
                        this.$toaster.success(res.data.message)
                        this.fetchcustomers();
                        this.clearForm();

                    } else {
                        this.$toaster.error(res.data.message)
                    }
                })
                .catch(error => {
                    this.error_message = '';
                    this.errors = new ErrorHandling();
                    if (error.response.status == 422) {
                        if (error.response.data.status == 'Error') {
                            this.error_message = error.response.data.message;
                        } else {
                            this.errors.record(error.response.data.errors);
                        }
                    }
                }).finally(() => (this.$parent.loading = false));

        },
        editcustomer(customer) {
            this.edit = true;
            this.display_form = 1;
            this.errors = new ErrorHandling();
            this.customerData.customer_id = customer.customer_id
            this.customerData.customer_first_name = customer.customer_first_name
            this.customerData.customer_last_name = customer.customer_last_name
            this.customerData.customer_email = customer.customer_email
            this.customerData.customer_hash = customer.customer_hash
            this.customerData.customer_avatar = customer.customer_avatar
            this.customerData.is_seen = customer.is_seen
            this.customerData.customer_status = customer.customer_status
            this.customerData.customer_address = customer.customer_address[0].street_address
            this.customerData.customer_address_id = customer.customer_address[0].id
            this.customerData.customer_city = customer.customer_address[0].city
            this.customerData.customer_zip = customer.customer_address[0].postcode
            this.customerData.customer_country_id = customer.customer_address[0].country_id.country_id
            this.customerData.customer_company_name = customer.customer_address[0].company
            this.customerData.customer_phone = customer.customer_address[0].phone
            this.customerData.customer_registration_number = customer.customer_registration_number
            this.customerData.customer_tax_number = customer.customer_tax_number
            this.customerData.company_address = customer.company_address
            this.customerData.bank = customer.customer_address[0].bank
            this.customerData.swift = customer.customer_address[0].swift
            this.customerData.iban = customer.customer_address[0].iban
            this.customerData.customer_kpp = customer.customer_kpp
            this.customerData.counterparty_type = customer.counterparty_type || 'company'
            this.customerData.bik = customer.customer_address[0].bik
            this.customerData.checking_account = customer.customer_address[0].checking_account
            this.customerData.corr_account = customer.customer_address[0].corr_account

        },
        clearForm() {
            this.edit = false;
            this.display_form = 0;
            this.customerData = {
                customer_kpp: "",
                counterparty_type: "company",
                bik: "",
                checking_account: "",
                corr_account: "",
                customer_id :"",
                customer_first_name :"",
                customer_last_name :"",
                customer_email :"",
                customer_hash :"",
                customer_avatar :"",
                is_seen :"",
                customer_status :"",
                password :"",
                customer_address: "",
                customer_city: "",
                customer_zip: "",
                customer_country_id: "",
                customer_company_name: "",
                customer_phone: "",
                customer_registration_number: "",
                customer_tax_number: "",
                company_address: "",
                customer_bank: "",
                customer_swift: "",
                customer_iban: "",
            }
        },
        sorting(sortBy) {
            this.sortBy = sortBy;
            this.sortType = this.sortType == 'asc' || this.sortType == 'ASC' ? this.sortType = 'desc' : this.sortType = 'asc';
            this.fetchcustomers();
        },
        clearSearch(){
            this.searchParameter = "",
            this.fetchcustomers();
        }
    },
    mounted() {

        var token = localStorage.getItem('token');
        this.token = {
            headers: {
                Authorization: `Bearer ${token}`
            }
        };
        this.fetchcustomers();
        this.fetchCountries();
    }
};
</script>
